import languageReducer from './reducers'

export { default as languageSelectors } from './selectors'
export { default as languageActions } from './actions'
export { default as languageTypes } from './actionTypes'

export default languageReducer
